// GENERATED FILE — DO NOT EDIT MANUALLY
// Generated from: public/config/domains/project.registry.yml
// Run `npm run codegen` to regenerate

export enum ProjectEvents {
  PROJECT_LOADED = "project_loaded",
  PROJECTS_LOADED = "projects_loaded",
  PROJECT_CREATED = "project_created",
  PROJECT_UPDATED = "project_updated",
  PROJECT_DELETED = "project_deleted",
  PROJECT_ERROR = "project_error",
  PROJECT_SELECTED = "project_selected",
  PROJECT_DESELECTED = "project_deselected",
  PROJECT_API_ERROR = "project_api_error",
  QUICKSTART_LOADED = "quickstart_loaded",
  QUICKSTART_ERROR = "quickstart_error",
  PROJECTS_LOADING = "projects_loading",
  STATE_UPDATED = "state_updated",
  STATE_RESET = "state_reset",
  ERROR_CLEARED = "error_cleared",
}

export enum ProjectEndpoints {
  LIST_PROJECTS = "/api/v1/projects",
  GET_PROJECT = "/api/v1/projects/:id",
  CREATE_PROJECT = "/api/v1/projects",
  UPDATE_PROJECT = "/api/v1/projects/:id",
  DELETE_PROJECT = "/api/v1/projects/:id",
  GET_PROJECT_APPLICATIONS = "/api/v1/projects/:id/applications",
  QUICKSTART_APPLICATIONS = "/api/v1/quickstart/applications",
}
